/**
 * 下载中心
 * @author sunxx
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
    async getData() {
        return request(api.report.CLUBREPORTMODULE, METHOD.GET);
    },
    async delData(id) {
        return request(api.report.DOWMLOADEL+'/'+id, METHOD.DELETE);
    },
    async delDataList(idList) {
        return request(api.report.DOWMLOADEL+'?idList='+idList, METHOD.DELETE);
    },

}


export default {dataApi}
